import { useRealtimeEvent } from '../contexts/RealtimeContext';
import { useToast } from '../contexts/ToastContext';

const STATUS_LABELS = {
  accepted: 'accepté',
  rejected: 'refusé',
  cancelled: 'annulé',
  pending: 'remis en attente',
};

/**
 * Affiche des toasts sur les événements temps réel (issue #36).
 * Composant sans UI propre — monté dans le Layout.
 * Les messages (badge + chat) sont gérés ailleurs, on ne les double pas ici.
 */
export default function RealtimeNotifier() {
  const { addToast } = useToast();

  useRealtimeEvent('booking:new', (data) => {
    const title = data?.eventTitle ? ` : ${data.eventTitle}` : '';
    addToast(`Nouvelle proposition de booking${title}`, 'success');
  });

  useRealtimeEvent('booking:status_changed', (data) => {
    const label = STATUS_LABELS[data?.status] || 'mis à jour';
    addToast(`Un booking a été ${label}`, label === 'refusé' || label === 'annulé' ? 'error' : 'success');
  });

  useRealtimeEvent('booking:counter_offer', (data) => {
    addToast(`Contre-proposition de cachet${data?.artistName ? ` de ${data.artistName}` : ''}`, 'success');
  });

  useRealtimeEvent('booker:request', (data) => {
    if (data?.direction === 'artist_to_booker') {
      addToast(`Nouvelle demande d'un artiste${data?.artistName ? ` : ${data.artistName}` : ''}`, 'success');
    } else {
      addToast(`Nouvelle invitation booker${data?.bookerCompanyName ? ` : ${data.bookerCompanyName}` : ''}`, 'success');
    }
  });

  return null;
}
